<template>
    <div class="right">
                <div class="right_0">
                    <!-- <poorQualityButton :bgColor="normalBgColor" :borderColor="normalBdColor"  :isClicked="poorQuality" @click="poorQualityFun">Poor quality</poorQualityButton> -->
                    <el-button :color="normalBgColor" style="width: 100%;height: 34px;margin-top: 5px;border-color: #BDBDBD;font-weight: 700;font-size: 16px;"
                       :style="{'background-color':poorQuality?normalBgColor:'#ffffff','border-color':poorQuality?normalBdColor:'#BDBDBD','color':'#333333'}" plain
                       @click="poorQualityFun"
                     >
                     Poor quality
                     </el-button>
                </div>
                <div class="right_1">
                    <div class="title">Diagnosis</div>
                    <div>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[0]" @clickFun="goodQualityFun(0,0)" :poorBtn="poorQuality">No Finding</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[1]" @clickFun="goodQualityFun(1,1)" :poorBtn="poorQuality">AMD</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[2]" @clickFun="goodQualityFun(2,2)" :poorBtn="poorQuality">DME/RVO</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[3]" @clickFun="goodQualityFun(3,4)" :poorBtn="poorQuality">MH</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[4]" @clickFun="goodQualityFun(4,8)" :poorBtn="poorQuality">HM</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[5]" @clickFun="goodQualityFun(5,16)" :poorBtn="poorQuality">RD</normalButton>
                        <normalButton :bgColor="normalBgColor" :borderColor="normalBdColor" :isClicked="disabledlist[6]" @clickFun="goodQualityFun(6,32)" :poorBtn="poorQuality">Other</normalButton>
                    </div>
                </div>
                <div class="right_2">
                    <div class="title">
                      <span>Finding</span>
                      <!-- <span class="left-text">自動標記<el-switch v-model="value1"  style="--el-switch-on-color: #3AC0CB; --el-switch-off-color: #D9D9D9" /></span> -->
                    </div>
                    <div>
                        <my-button :poorBtn="poorQuality" :bgColor="puckerBgColor" :cricleColor="puckerColor" :selectBtn="selectBtn[2]" @clickFun="checkFun(2,puckerColor,'Pucker')" @keyFun="keyFun" :keyWord="'F1'" >Pucker</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="IRCBgColor" :cricleColor="IRCColor" :selectBtn="selectBtn[3]"  @clickFun="checkFun(3,IRCColor,'IRC')" @keyFun="keyFun" :keyWord="'F2'">IRC</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="SRFBgColor" :cricleColor="SRFColor" :selectBtn="selectBtn[4]"  @clickFun="checkFun(4,SRFColor,'SRF')" @keyFun="keyFun" :keyWord="'F3'">SRF</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="RPEDBgColor" :cricleColor="RPEDColor" :selectBtn="selectBtn[5]"  @clickFun="checkFun(5,RPEDColor,'RPED')" @keyFun="keyFun" :keyWord="'F4'">RPED</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="atrophyBgColor" :cricleColor="atrophyColor" :selectBtn="selectBtn[6]" @clickFun="checkFun(6,atrophyColor,'RPE atrophy')" @keyFun="keyFun" :keyWord="'F5'">RPE atrophy</my-button>
                        <!-- <my-button :poorBtn="poorQuality" :bgColor="SkipBgColor" :cricleColor="SkipColor" :selectBtn="selectBtn[7]"  @clickFun="checkFun(7,SkipColor,'Skip')" @keyFun="keyFun" :keyWord="'F6'">Skip</my-button> -->
                        <my-button :poorBtn="poorQuality" :bgColor="SRHMBgColor" :cricleColor="SRHMColor" :selectBtn="selectBtn[8]" @clickFun="checkFun(8,SRHMColor,'SRHM')" @keyFun="keyFun" :keyWord="'F6'">SRHM</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="DrusenBgColor" :cricleColor="DrusenColor" :selectBtn="selectBtn[9]" @clickFun="checkFun(9,DrusenColor,'Drusen')" @keyFun="keyFun" :keyWord="'F7'">Drusen</my-button>
                        <my-button :poorBtn="poorQuality" :bgColor="HFBgColor" :cricleColor="HFColor" :selectBtn="selectBtn[1]" @clickFun="checkFun(1,HFColor,'HF')" @keyFun="keyFun" :keyWord="'F8 '">HF</my-button>
                    </div>
                </div>
                <div class="right_4">
                  <div v-if="!btnFlag">
                      <div class="title">
                        <span>Patient</span>
                      </div>
                      <div style="width: 100%;">
                        <el-button-group style="width:100%;display:flex;margin: 3px auto;">
                          <el-button style="--el-color-primary:#3AC0CB"  @click="backPFun"><el-Icon><ArrowLeft style="color:#333333" /></el-Icon></el-button>
                          <el-input ref="patienInput" class="number" v-if="patientChangeInput" style="--el-color-primary:#3AC0CB" v-model="patientInput" @change="patientInputFun" @blur="patientInputFun" autofocus="true"></el-input>
                          <div class="number" v-else  @click="changeScanByInput(0)" >{{ patientTotal!==0?num:'N' }}/{{ patientTotal!==0?patientTotal:'A' }}</div>
                          <el-button style="--el-color-primary:#3AC0CB"  @click="nextPFun"><el-Icon><ArrowRight style="color:#333333"/></el-Icon></el-button>
                        </el-button-group>
                      </div>
                    </div>
                  <div class="title">
                      <span>Scan</span>
                  </div>
                  <div style="width: 100%;">
                    <el-button-group style="width:100%;display:flex;margin: 3px auto;">
                      <el-button style="--el-color-primary:#3AC0CB"  @click="backSFun"><el-Icon><ArrowLeft style="color:#333333" /></el-Icon></el-button>
                      <el-input ref='scanInput' class="number" v-if="scanChangeInput" style="--el-color-primary:#3AC0CB" v-model="scanInput" @change="scanInputFun($event)" @mouseout="scanChangeInput=false"></el-input>
                      <div class="number" v-else  @click="changeScanByInput(1)">{{ scanTotal!==0?scanNum:'N' }}/{{ scanTotal!==0?scanTotal:'A' }}</div>
                      <el-button style="--el-color-primary:#3AC0CB"  @click="nextSFun"><el-Icon><ArrowRight style="color:#333333"/></el-Icon></el-button>
                    </el-button-group>
                  </div>
                  <div class="botbtn">
                    <el-button :style="{'background-color':$store.getters.getApproveStatus?'#E8FCFF':'#ffffff','border-color': '#00A1AE','color':'#00A1AE'}" v-if="btnFlag" @click="ApproveFun">
                            <img src="@/assets/images/approve.png" class="imgclass_2">
                            {{ $store.getters.getApproveStatus?'Approved':'Approve' }}</el-button>
                    <el-button   @click="saveFun()" :style="{'background-color':saveDisabled?'#8FCCA0':'#3AC0CB'}">
                            <img src="@/assets/images/save.png" class="imgclass_2">
                            Save</el-button>
                  </div>
            </div>

      <el-dialog
          v-model="dialogVisible"
          :title="errorInfo.title"
          width="500"
          :before-close="handleClose"
          :close-on-click-modal="false" :close-on-press-escape="false"
          class="cancelDia"
        >
          <div>
            <span>{{ errorInfo.message }}</span>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <div>
                <el-button  @click="cancelLeave" style="--el-color-primary:#3AC0CB;">
                 Cancel
                </el-button>
                <el-button  @click="DonSave" style="--el-color-primary:#3AC0CB;">
                 Don't Save
                </el-button>
                <el-button type="primary" @click="SaveAgain(errorInfo.type)" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;">
                 {{ errorInfo.type===1?'Save and Leave':'Save Again' }}
                </el-button>
              </div>
            </span>
          </template>
        </el-dialog>
    </div>
</template>

<script>
import myButton from '@/components/myButton.vue'
import normalButton from '@/components/normalButton.vue'
// import fileUpload from '@/components/fileUpload.vue'
import { batchTxtFile } from '@/api/index.js'
import { computeMD5 } from '@/utils/index.js'
import { ElMessageBox } from 'element-plus'
export default {
  name: 'operatePart',
  props: {
    btnFlag: {
      type: Boolean,
      default: false
    },
    scanTotal: {
      type: Number,
      default: 0
    },
    patientTotal: {
      type: Number,
      default: 0
    },
    sliceIndex: {
      type: Number,
      default: 0
    },
    scanIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    myButton, normalButton
    // fileUpload
  },
  data () {
    return {
      // 按钮颜色
      // 绿色
      greenColor: '#00BB34',
      // 红色
      redColor: '#D62E2E',
      // Pucker
      puckerColor: '#00FFF0',
      puckerBgColor: '#CCFFFC',

      // IRC
      IRCColor: '#FFC700',
      IRCBgColor: '#FFF4CC',

      // SRF
      SRFColor: '#FF00B8',
      SRFBgColor: '#FFCCF1',

      // RPED
      RPEDColor: '#FF4C00',
      RPEDBgColor: '#FFDBCC',

      // Skip
      SkipColor: '#AE6EFF',
      SkipBgColor: '#F1E5FF',

      // SRHM
      SRHMColor: '#03FF4A',
      SRHMBgColor: '#CCFFDA',

      // RPE atrophy
      atrophyColor: '#0094FF',
      atrophyBgColor: '#D0CCFF',

      // Drusen
      DrusenColor: '#FFF859',
      DrusenBgColor: 'rgb(235 219 171)',
      // HF
      HFColor: '#FFAAF1',
      HFBgColor: '#FFCCCC',

      // normalColor
      normalBdColor: '#00919D',
      normalBgColor: '#E8FCFF',

      selectBtn: new Array(10).fill(false), /// 控制标志按钮单选
      disabledlist: new Array(7).fill(false),
      saveDisabled: false,
      exitDisabled: false,
      deleteDisabled: false,
      value1: false,

      num: 1,
      total: 100000,
      scanNum: 1,
      // scanTotal: 100,
      diagnosisBtnList: [],
      btnId: 0,
      diagnosisList: {},
      md5List: [],
      fileTxtList: [],
      dialogVisible: false,
      errorInfo: {
        type: 0,
        title: 'Message',
        message: 'Saving failed! do you want to save again?'
      },
      donsaveFlag: false, /// 選擇不保存時標志
      openDialogFlag: 0, /// 打開dialog的位置,save:0,scan-back:1,scan-next:2,patient-back:3,patient-next:4
      scanChangeInput: false, // 点击出现scan输入框
      scanInput: null, /// 输入scan切换
      patientInput: null,
      patientChangeInput: false,
      poorQuality: false

    }
  },
  watch: {
    sliceIndex (newval, oldval) {
      // if (newval !== oldval) {
      this.diagnosisBtnList = []
      this.poorQuality = this.$store.getters.getPoorQuality
      this.getdiagnosis()
      // }
    },
    scanIndex (newval, oldval) {
      console.log('newvalscanIndex', newval)
      if (newval === 0) {
        this.scanNum = 1
      }
      console.log('newvalscanIndex', newval)

      this.diagnosisBtnList = []
      this.poorQuality = this.$store.getters.getPoorQuality
      this.getdiagnosis()
      setTimeout(() => {
        this.scanNum = newval + 1
      }, 1000)
    },
    scanTotal (newval, oldval) {
      console.log('scanTotal', this.scanTotal)
      this.scanNum = 1
      this.diagnosisBtnList = []
      this.poorQuality = this.$store.getters.getPoorQuality
      this.getdiagnosis()
    }
  },
  created () {
    window.addEventListener('keydown', this.keydownFun, true)
  },
  beforeUnmount () {
    window.removeEventListener('keydown', this.keydownFun, true)
  },
  mounted () {
    this.poorQuality = this.$store.getters.getPoorQuality
    window.onbeforeunload = e => {
      console.log(e)
      const ret = this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0
      if (ret) {
        // 阻止默认的弹出框
        event.preventDefault()
        // 设置返回值为null，以解决Firefox中的一个问题
        event.returnValue = null
        this.errorInfo = {
          type: 1,
          title: 'Unsaved Changes',
          message: 'This data has not been saved, do you want to leave?'
        }
        this.dialogVisible = true
        // return true
        return 'This data has not been saved, do you want to leave?'
      }
    }
  },
  methods: {
    /// 刷新页面或退出或refresh时，弹出未保存提醒
    doSaveNowFun () {
      if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) {
        this.errorInfo = {
          type: 1,
          title: 'Unsaved Changes',
          message: 'This scan has not been saved, do you want to leave?'
        }
        this.dialogVisible = true
        return true
      } else {
        return false
      }
    },

    /// 新增poorquality按钮
    poorQualityFun () {
      const status = this.$store.getters.getPoorQuality
      this.$store.commit('setpoorQualityStatus', !status)
      this.poorQuality = this.$store.getters.getPoorQuality
      if (this.poorQuality) {
        this.diagnosisBtnList = []
        this.disabledlist = new Array(7).fill(false)
        const diag = {
          dia: this.diagnosisBtnList,
          doctor: this.$store.state.user.doctorName
        }
        this.$store.commit('pushDiagnosis', diag)
        // this.selectBtn = new Array(10).fill(false)
        /// 清空画笔区
        this.clearDraw()
      }
    },
    clearDraw () {
      const id = this.selectBtn.findIndex(item => item)

      switch (id) {
        case 2:
          this.checkFun2(2, this.puckerColor, 'Pucker')
          break
        case 3:
          this.checkFun2(3, this.IRCColor, 'IRC')
          break
        case 4:
          this.checkFun2(4, this.SRFColor, 'SRF')
          break
        case 5:
          this.checkFun2(5, this.RPEDColor, 'RPED')
          break
        case 6:
          this.checkFun2(6, this.atrophyColor, 'RPE atrophy')
          break
        // case 7:
        //   this.checkFun(7, this.SkipColor, 'Skip')
        //   break
        case 8:
          this.checkFun2(8, this.SRHMColor, 'SRHM')
          break
        case 9:
          this.checkFun2(9, this.DrusenColor, 'Drusen')
          break
        case 1:
          this.checkFun2(1, this.HFColor, 'HF')
          break
        default:
          break
      }
    },
    async patientInputFun () {
      if (/^\d+$/.test(this.patientInput)) {
        if (this.patientInput > 0 && this.patientInput <= this.patientTotal) {
          this.scanNum = 1
          this.num = this.patientInput
          const obj = {
            flag: 'patient',
            index: this.patientInput - 1
          }
          if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存->自动保存
            this.donsaveFlag = false
            this.openDialogFlag = 3
            await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)
          this.patientChangeInput = false
          this.patientInput = null
        } else {
          this.patientChangeInput = false
          this.patientInput = null
        }
      } else {
        this.patientChangeInput = false
        this.patientInput = null
      }
    },
    async scanInputFun () {
      console.log(this.scanInput)
      if (/^\d+$/.test(this.scanInput)) {
        if (this.scanInput > 0 && this.scanInput <= this.scanTotal) {
          this.scanNum = this.scanInput
          const obj = {
            flag: 'scan',
            index: this.scanInput - 1
          }
          if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存,->自动保存
            this.donsaveFlag = false
            this.openDialogFlag = 3
            await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)
          this.scanChangeInput = false
          this.scanInput = null
        } else {
          this.scanChangeInput = false
          this.scanInput = null
        }
      } else {
        this.scanChangeInput = false
        this.scanInput = null
      }
    },
    changeScanByInput (type) {
      if (type === 1 && this.scanTotal > 0) {
        this.scanChangeInput = true
        this.$nextTick(() => {
          this.$refs.scanInput.focus()
        })
      } else if (type === 0 && this.patientTotal > 0) {
        this.patientChangeInput = true
        this.$nextTick(() => {
          this.$refs.patienInput.focus()
        })
      } else {
        this.patientChangeInput = false
        this.scanChangeInput = false
      }
    },
    /// 获取当前图片的diagnosis并显示
    getdiagnosis () {
      let diagnosisList = null
      diagnosisList = this.$store.getters.getDiagnosis
      console.log('diagnosisList ', diagnosisList)
      if (diagnosisList.dia !== {} && diagnosisList.dia) {
        this.diagnosisList = diagnosisList.dia
        this.diagnosisBtnList = []
        this.disabledlist = new Array(7).fill(false)
        console.log('this.diagnosisList ', this.diagnosisList)
        for (let i = 0; i < this.diagnosisList.length; i++) {
          this.goodQualityFun(9, this.diagnosisList[i])
        }
      } else {
        this.disabledlist = new Array(7).fill(false)
      }
      console.log('this.disabledlist ', this.disabledlist)
    },
    handleClose () {
      this.dialogVisible = false
    },
    keydownFun (e) {
      console.log('e', e)
      if (e.keyCode === 38) { // up键
        this.nextPFun()
      } else if (e.keyCode === 40) { // down键
        this.backPFun()
      } else if (e.keyCode === 37) { // left键
        this.backSFun()
      } else if (e.keyCode === 39) { // right键
        this.nextSFun()
      } else if (e.ctrlKey && e.keyCode === 83) {
        console.log('ctrl+s')
        this.saveFun()
      } else if (e.key === 'F1' || e.key === 'F2' || e.key === 'F3' || e.key === 'F4' || e.key === 'F5' || e.key === 'F6' || e.key === 'F7' || e.key === 'F8') {
        e.preventDefault()
        // this.$emit('keyFun', e.key)
        this.keyFun(e.key)
      } else if (e.key === 'Delete') {} else {
        e.stopPropagation()
      }
    },
    checkFun (id, color, text) {
      if (this.$store.state.list.length !== 0 && !this.poorQuality) {
        let flag = false
        this.selectBtn.filter((item, i) => {
          if (i === id) {
            this.selectBtn[i] = !this.selectBtn[i]

            if (this.selectBtn[id]) {
              flag = true
              this.btnId = id
            }
          } else {
            this.selectBtn[i] = false
          }

          console.log('this.selectBtn', this.selectBtn)
        })
        // console.log('this.selectBtn', this.selectBtn)
        // console.log('flag', this.selectBtn)

        const data = {
          color: color,
          text: text,
          id: id,
          drawFlag: flag
        }
        this.$emit('drawFun', data)
      }
    },
    checkFun2 (id, color, text) {
      if (this.$store.state.list.length !== 0) {
        const flag = this.selectBtn[id]
        const data = {
          color: color,
          text: text,
          id: id,
          drawFlag: !flag
        }

        this.selectBtn = new Array(10).fill(false)
        this.selectBtn[id] = !flag
        console.log('this.selectBtn ', this.selectBtn)
        this.$emit('drawFun', data)
      }
    },
    keyFun (key) {
      console.log('key', key)
      if (this.$store.state.list.length !== 0 && !this.poorQuality) {
        switch (key) {
          case 'F1':
            this.checkFun2(2, this.puckerColor, 'Pucker')
            break
          case 'F2':
            this.checkFun2(3, this.IRCColor, 'IRC')
            break
          case 'F3':
            this.checkFun2(4, this.SRFColor, 'SRF')
            break
          case 'F4':
            this.checkFun2(5, this.RPEDColor, 'RPED')
            break
          case 'F5':
            this.checkFun2(6, this.atrophyColor, 'RPE atrophy')
            break
          // case 'F6':
          //   this.checkFun(7, this.SkipColor, 'Skip')
          //   break
          case 'F6':
            this.checkFun2(8, this.SRHMColor, 'SRHM')
            break
          case 'F7':
            this.checkFun2(9, this.DrusenColor, 'Drusen')
            break
          case 'F8':
            this.checkFun2(1, this.HFColor, 'HF')
            break
          default:
            break
        }
      }
    },
    goodQualityFun (flag, value) {
      if (!this.poorQuality) {
        console.log('点击了 goodQuality')
        this.disabledlist[flag] = !this.disabledlist[flag]
        if (flag === 0) {
          this.diagnosisBtnList = []
          this.diagnosisBtnList.push(value)
          this.disabledlist = new Array(7).fill(false)
          this.disabledlist[0] = true
          const diag = {
            dia: this.diagnosisBtnList,
            doctor: this.$store.state.user.doctorName
          }
          this.$store.commit('pushDiagnosis', diag)
        } else if (flag === 9) {
        // if (value !== 0) {
          this.diagnosisBtnList.push(value)
          switch (value) {
            case 0:
              this.disabledlist[0] = true
              break
            case 1:
              this.disabledlist[1] = true
              break
            case 2:
              this.disabledlist[2] = true
              break
            case 4:
              this.disabledlist[3] = true
              break
            case 8:
              this.disabledlist[4] = true
              break
            case 16:
              this.disabledlist[5] = true
              break
            case 32:
              this.disabledlist[6] = true
              break
            default:
              break
          }
        // }
        } else {
        /// 删除nofinding的数据
          const index = this.diagnosisBtnList.indexOf(0)
          if (index !== -1) {
            this.diagnosisBtnList.splice(index, 1)
          }
          const index2 = this.diagnosisBtnList.indexOf(value)
          if (index2 === -1) {
            this.diagnosisBtnList.push(value)
          } else {
            this.diagnosisBtnList.splice(index2, 1)
          }
          this.disabledlist[0] = false
          const diag = {
            dia: this.diagnosisBtnList,
            doctor: this.$store.state.user.doctorName
          }
          this.$store.commit('pushDiagnosis', diag)
        }
      } else {
        this.diagnosisBtnList = []
        this.disabledlist = new Array(7).fill(false)
      }
    },
    async backPFun () {
      if (this.num > 1 && this.$store.state.list.length !== 0) {
        if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存
          // this.errorInfo = {
          //   type: 1,
          //   title: 'Unsaved Changes',
          //   message: 'This scan has not been saved, do you want to leave?'
          // }
          // this.dialogVisible = true
          this.donsaveFlag = false
          this.openDialogFlag = 3
          await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
        } else if (this.num > 1) {
          this.scanNum = 1
          this.num--
          const obj = {
            flag: 'patient',
            index: this.num - 1
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)

          this.dialogVisible = false
          this.donsaveFlag = false
          this.openDialogFlag = 0
        }
      }
    },
    async nextPFun () {
      if (this.num < this.patientTotal && this.$store.state.list.length !== 0) {
        if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存
          // this.errorInfo = {
          //   type: 1,
          //   title: 'Unsaved Changes',
          //   message: 'This scan has not been saved, do you want to leave?'
          // }
          // this.dialogVisible = true
          this.donsaveFlag = false
          this.openDialogFlag = 4
          await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
        } else if (this.num < this.total) {
          this.scanNum = 1
          this.num++
          const obj = {
            flag: 'patient',
            index: this.num - 1
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)
          this.dialogVisible = false
          this.donsaveFlag = false
          this.openDialogFlag = 0
        }
      }
    },
    async backSFun () {
      if (this.scanNum > 1 && this.$store.state.list.length !== 0) {
        if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存
          // this.errorInfo = {
          //   type: 1,
          //   title: 'Unsaved Changes',
          //   message: 'This scan has not been saved, do you want to leave?'
          // }
          // this.dialogVisible = true
          this.donsaveFlag = false
          this.openDialogFlag = 1
          await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
        } else if (this.scanNum > 1) {
          this.scanNum--
          const obj = {
            flag: 'scan',
            index: this.scanNum - 1
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)
          this.dialogVisible = false
          this.donsaveFlag = false
          this.openDialogFlag = 0
          // this.disabledlist = new Array(7).fill(false)
        }
      }
    },
    async nextSFun () {
      if (this.scanNum < this.scanTotal && this.$store.state.list.length !== 0) {
        console.log('this.$store.getters.getEditAndSavedStatus', this.$store.getters.getEditAndSavedStatus)
        if (this.$store.getters.getEditAndSavedStatus && !this.donsaveFlag && this.openDialogFlag === 0) { // 修改且未保存
          this.donsaveFlag = false
          this.openDialogFlag = 2
          await this.SaveAgain(1, true)// errorflag不显示保存成功的提示消息
        } else if (this.scanNum < this.scanTotal) {
          this.scanNum++
          const obj = {
            flag: 'scan',
            index: this.scanNum - 1
          }
          this.selectBtn = new Array(10).fill(false)
          this.$emit('changeNum', obj)
          this.dialogVisible = false
          this.donsaveFlag = false
          this.openDialogFlag = 0
          // this.disabledlist = new Array(7).fill(false)
        }
      } else if (this.scanNum === this.scanTotal && this.scanTotal === 20) {
        ElMessageBox.alert('Review the next batch of data (20 sets)', 'Message', {
          confirmButtonText: 'OK',
          callback: (action) => {
            this.$emit('changeLabelModel', '2-3')
          }
        })
      }
    },
    /// 同意当前AI诊断结果，无需修改
    ApproveFun () {
      const status = this.$store.getters.getApproveStatus
      this.$store.commit('setApproveStatus', !status)
    },
    /// 生成当前scan的txt并保存
    async saveFun (errorflag) {
      if (this.$store.state.list.length !== 0) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        // this.saveDisabled = !this.saveDisabled
        const sliceData = this.$store.state.sliceData/// 当前scan，下面包含了n个slice
        this.fileTxtList = []
        this.md5List = []
        const txtContList = []
        for (let j = 0; j < sliceData.list.length; j++) { /// 一个slice生成一个txt
          let diag = {}; let drawData = []; const approveList = []; let filename = ''
          const li = sliceData.list[j]
          if (li.editStatus) {
            if (li.diag.dia && li.diag.dia.length !== 0) {
              let sum = 0
              sum = li.diag.dia.reduce(function (pre, curr) { sum = pre + curr; return sum })
              const obj = {
                num: sum,
                doctor: li.diag.doctor
              }
              diag = obj
            }
            if (li.drawList.length !== 0) {
              drawData = li.drawList
            }
            const n1 = li.pngFileName.substr(0, li.pngFileName.length - 5)
            // console.log(n1)
            filename = `${n1}0.txt`
            // console.log(filename)
            if (li.approved) {
              let str = filename.substr(0, filename.length - 5)
              str = str + '1.txt'
              approveList.push(str)
              filename = str
            }
            if (diag !== {} || drawData.length !== 0 || approveList.length !== 0) {
              const txtCon = this.createTxtData(diag, drawData, approveList)
              const obj = {
                txtCon: txtCon,
                filename: filename
              }
              txtContList.push(obj)
            }
          }
        }
        console.log('txtContList', txtContList)

        for (let i = 0; i < txtContList.length; i++) {
          this.createTxtFile(txtContList[i].txtCon, txtContList[i].filename)
        }
        /// 等待數據md5結果返回後才發送請求
        setTimeout(async () => {
          if (this.fileTxtList.length !== 0 && this.md5List.length === this.fileTxtList.length) {
            const headers = {
              'Content-Type': 'multipart/form-data'
            }
            const md5 = []
            this.md5List.forEach(item => {
              md5.push(item)
            })
            const params = {
              file: this.fileTxtList,
              md5: this.md5List
            }
            const { code, data } = await batchTxtFile(params, headers)
            // const code = 201; const data = []
            console.log(code, data)

            loading.close()
            if (code === 200) {
              if (!errorflag) {
                this.$message({
                  message: 'Save success!',
                  type: 'success'
                })
              }
              this.$store.commit('setSaveStatus', true)
              this.dialogVisible = false
              if (JSON.parse(window.sessionStorage.getItem('isLoginOut'))) {
                window.sessionStorage.removeItem('user')
                window.sessionStorage.removeItem('isLoginOut')
                this.$router.push('/login')
                location.reload()
              }
            } else {
              if (!errorflag) {
                this.$message({
                  message: 'Saving failed !',
                  type: 'error'
                })
                this.errorInfo = {
                  type: 0, /// 弹出框显示类型，0表示保存失败提示，1表示未保存弹出提醒
                  title: 'Message',
                  message: 'Saving failed ! do you want to save again?'
                }
              }
              this.dialogVisible = true
              this.openDialogFlag = 0
            }
            loading.close()
          } else {
            loading.close()
          }
        }, 1000)
        setTimeout(() => {
          loading.close()
        }, 2000)
      }
    },
    uploadProgress (ps) {
      console.log('ps', ps)

      console.log(`进度：${Math.floor(
        (ps.loaded / ps.total) * 100
      )}%`)
    },
    async SaveAgain (type, errorflag) {
      this.dialogVisible = false
      const error = errorflag || false// 是否显示保存接口返回的提示信息
      await this.saveFun(error)
      setTimeout(() => {
        if (type === 1) { /// 未保存时提醒
          // 跳轉到下一個scan
          switch (this.openDialogFlag) {
            case 1:
              this.backSFun()
              break
            case 2:
              this.nextSFun()
              break
            case 3:
              this.backPFun()
              break
            case 4:
              this.nextPFun()
              break
            default:
              break
          }
        }
      }, 2000)
    },
    cancelLeave () {
      this.dialogVisible = false
      window.sessionStorage.removeItem('isLoginOut')
    },
    DonSave () {
      this.donsaveFlag = true
      switch (this.openDialogFlag) {
        case 1:
          this.backSFun()
          break
        case 2:
          this.nextSFun()
          break
        case 3:
          this.backPFun()
          break
        case 4:
          this.nextPFun()
          break
        default:
          break
      }
      if (JSON.parse(window.sessionStorage.getItem('isLoginOut'))) {
        window.sessionStorage.removeItem('user')
        window.sessionStorage.removeItem('isLoginOut')
        this.$router.push('/login')
        location.reload()
      }
      this.dialogVisible = false
    },
    /// 生成txt的内容
    createTxtData (diag, drawData, approveList) {
      let str = ''
      if (diag.num) {
        str += `${diag.num} ${diag.doctor}` + '\r\n'
      }
      if (drawData.length !== 0) {
        for (let i = 0; i < drawData.length; i++) {
          // str += `${drawData[i].id} ${drawData[i].x} ${drawData[i].y} ${drawData[i].w} ${drawData[i].h}  ${drawData[i].doctor === '' ? 'AI' : drawData[i].doctor}  [${drawData[i].originWidth ? drawData[i].originWidth : 0},${drawData[i].originHeight ? drawData[i].originHeight : 0}]  ${drawData[i].direction !== 'NAN' && drawData[i].direction ? drawData[i].direction : 0}` + '\r\n'
          str += `${drawData[i].id} ${drawData[i].x} ${drawData[i].y} ${drawData[i].w} ${drawData[i].h}  ${drawData[i].doctor === '' ? 'AI' : drawData[i].doctor}  ${drawData[i].direction !== 'NAN' && drawData[i].direction ? drawData[i].direction : 0}` + '\r\n'
        }
      }
      if (approveList.length !== 0) {
        for (let i = 0; i < approveList.length; i++) {
          str += `${approveList[i]}` + '\r\n'
        }
      }
      // if (this.poorQuality) {
      str += `poorQuality ${this.poorQuality ? 1 : 0}` + '\r\n'
      // }
      return str
    },
    /// 生成txt档文件
    async createTxtFile (content, filename) {
      console.log('content', content)

      const fileContent = new File([content], filename, { type: 'txt' })
      // const file = new FileReader(fileContent)
      // console.log(fileContent)
      this.fileTxtList.push(fileContent)
      const md5 = await computeMD5(fileContent).then()
      console.log(md5, filename)
      this.md5List.push(md5)
    }
    // /// 計算文件的md5值
    // computeMD5 (param) {
    //   const file = param
    //   const sliceLength = 1024 * 1024 * 10/// // 切片默认大小10M
    //   let retMd5 = ''
    //   const fileReader = new FileReader()
    //   const md5 = new SparkMD5()
    //   let index = 0
    //   const loadFile = () => {
    //     const slice = file.slice(index, index + sliceLength)
    //     fileReader.readAsBinaryString(slice)
    //   }
    //   loadFile()
    //   fileReader.onload = e => {
    //     md5.appendBinary(e.target.result)
    //     if (index < file.size) {
    //       // console.log('切片', index)
    //       index += sliceLength
    //       loadFile()
    //     } else {
    //       retMd5 = md5.end()// 就是文件md5码
    //       // console.log(retMd5)
    //       this.md5List.push(retMd5)/// txt文件不大，所以生成md5基本不会延迟，不行！！
    //     }
    //   }
    //   return retMd5
    // }
  }
}
</script>

<style lang="less" scoped>
.title{
    font-size: 20px;
    font-weight: 700;
    color: #2A2A2A;
    text-align: left;
    display: flex;
    justify-content: space-between;
    .left-text{
      font-size: 14px;
      font-weight: 400;
      color:#999999 ;
    }
}
.right_0{
  .el-button{
            // justify-content:left;
            border-color: #2A2A2A;
            div{
                margin-right: 10px;
            }
      }
}
.right_1{
        // height:35%;
        // background-color: aqua;
        // border: 1px solid;
        .el-button{
            // justify-content:left;
            border-color: #2A2A2A;
            div{
                margin-right: 10px;
            }
        }
        .el-button+.el-button {
             margin-left: 0!important;
        }
    }
    .right_2{
        margin-top: 5px;
        // flex:1;
        // background-color: aqua;
        .el-button{
            // justify-content:left;
            div{
                margin-right: 10px;
            }
        }
        .el-button+.el-button {
             margin-left: 0!important;
        }
        .rowBtn{
            margin-top: 15px;
            .el-button{
                font-weight: 700;
                font-size: 16px;
            }
            .el-button:nth-child(1){
                border-color: #2A2A2A;
                color:#B3B3B3;
            }
            .el-button:nth-child(2){
                border-color: #2A2A2A;
                color:#B3B3B3
            }
            .el-button+.el-button {
             margin-left: 1.25rem!important;
           }
        }
    }
    .right_4{
        width: 100%;
        // height: 20%;
        .number{
          float: left;
          flex:1;
          height: 32px;
          line-height:32px;
          border: 1px solid #BDBDBD;
          background-color: #fff;
          border-left:0;
          border-right:0;
          color:#333333
        }
        .botbtn{
          .el-button+.el-button {
             margin-left: 0!important;
          };
          .el-button{
            width: 100%;
            height: 40px;
            margin-top: 10px;
            // justify-content: left;
            font-size: 16px;
            font-weight: 700;
            color: #FFFFFF;
            background: #3AC0CB;
            .imgclass_2{
              width: 1.5625rem;
              margin-right:10px;
            }
          }

        }
    }
    .right_3{
        width: 100%;
        height: 20%;
        // background-color: rgb(37, 78, 78);
        .el-button+.el-button {
             margin-left: 0!important;
        };
        .el-button{
            width: 80%;
            height: 36.5px;
            margin-top: 10px;
            justify-content: left;
            font-size: 16px;
            font-weight: 700;

                .imgClass_1{
                    width: 1.5625rem;
                    margin-right: 3.75rem;
                }
                .imgClass_2{
                    width: 1.5625rem;
                    margin-right: 5rem;
                }
        }
        .el-button:nth-child(1){
            color: #2A2A2A;
            background: #FFFFFF;
            border-color: #2A2A2A;
            img{
                width: 1.5625rem;
                margin-right: 3.75rem;
            }
        }
        .el-button:nth-child(2),.el-button:nth-child(3){
            color: #FFFFFF;
            background: #00BB34;
            img{
                width: 1.5625rem;
                margin-right: 5rem;
            }
        }
        .el-button:nth-child(2){
            background: #00BB34;
        }
        .el-button:nth-child(3){
            background: #D62E2E;
        }

    }
</style>
